import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-userhome-fxhg",
  "use": "icon-userhome-fxhg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-userhome-fxhg\"><g style=\"mix-blend-mode:passthrough\"><g><g style=\"mix-blend-mode:passthrough\"><path d=\"M5,1L1,1L1,5L5,5L5,1ZM15,1L6,1L6,5L15,5L15,1ZM5,6L1,6L1,10L5,10L5,6ZM15,6L6,6L6,10L15,10L15,6ZM1,11L5,11L5,15L1,15L1,11ZM6,11L15,11L15,15L6,15L6,11Z\" fill-rule=\"evenodd\" fill=\"currentColor\" fill-opacity=\"1\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol